import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CheckIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks } from "../data/site";
type Status = "idle" | "error" | "success";
export function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? "success" : "error");
  };
  return <footer className="p-3 pt-24 md:p-5 md:pt-32" data-id="element-33" data-mp="3991omvfnkca">
      <div className="mx-auto max-w-[1320px] px-2 pb-20 md:px-5" data-id="element-34" data-mp="37xvkgeim0i0">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-end" data-id="element-35" data-mp="3ldanjfu8c3jw">
          <h2 className="font-serif text-4xl leading-[1.1] md:text-6xl" data-id="element-36" data-mp="3qd6pzana3mxc">
            Ne manquez pas <span className="italic" data-id="element-37" data-mp="29z6ss7ftibds">le décollage.</span>
          </h2>
          <form onSubmit={submit} noValidate className="w-full" data-id="element-38" data-mp="29xvrqfdrbhqd">
            <label htmlFor="newsletter" className="text-navy-soft" data-id="element-39" data-mp="2ezbbm4477i76">
              Recevez les annonces du programme et l'ouverture des inscriptions.
            </label>
            {status === "success" ? <p className="mt-4 flex items-center gap-3 rounded-full bg-sky px-6 py-4 font-medium text-navy" role="status" data-id="element-40" data-mp="3gbr0cm0dsxe2">
                <CheckIcon className="h-5 w-5" data-id="element-41" data-mp="3v916dfu99b2e" /> Merci ! Vous êtes inscrit·e.
              </p> : <div className="mt-4 flex rounded-full border border-navy/20 bg-white p-1.5 focus-within:border-navy" data-id="element-42" data-mp="3qazrz87rxzx9">
                <input id="newsletter" type="email" value={email} onChange={e => {
              setEmail(e.target.value);
              setStatus("idle");
            }} placeholder="votre@email.fr" aria-invalid={status === "error"} aria-describedby={status === "error" ? "newsletter-error" : undefined} className="min-w-0 flex-1 bg-transparent px-5 text-navy placeholder:text-navy/40 focus:outline-none" data-id="element-43" data-mp="3474fms9a7yq" />
                <button type="submit" className="whitespace-nowrap rounded-full bg-red px-6 py-3 font-semibold text-white transition-colors duration-150 hover:bg-red-deep" data-id="element-44" data-mp="yu7g0n81bhw3">
                  S'inscrire
                </button>
              </div>}
            {status === "error" && <p id="newsletter-error" className="mt-2 pl-5 text-sm text-wing" data-id="element-45" data-mp="18ltx30720b6r">
                Merci de saisir une adresse e-mail valide.
              </p>}
          </form>
        </div>
      </div>

      <div className="rounded-[28px] bg-navy text-cream md:rounded-[36px]" data-id="element-46" data-mp="1mk1rb0cpgye8">
        <div className="mx-auto flex max-w-[1320px] flex-col gap-10 px-6 py-12 md:flex-row md:items-start md:justify-between md:px-10" data-id="element-47" data-mp="1mhpfz61gdma5">
          <div className="max-w-xs" data-id="element-48" data-mp="3obokn8k2l5dv">
            <Logo light size="lg" data-id="element-49" data-mp="3ocpz7n0aoa0c" />
            <p className="mt-4 text-sm leading-relaxed text-cream/70" data-id="element-50" data-mp="3ta8ahk1sb1bi">
              Association organisatrice du 50ème anniversaire du parapente. Mieussy, Haute-Savoie — berceau mondial du parapente.
            </p>
          </div>
          <nav aria-label="Pied de page" data-id="element-51" data-mp="25o570b39nd8z">
            <ul className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm" data-id="element-52" data-mp="25mamuyztjp5y">
              {navLinks.map(l => <li key={l.to} data-id="element-53" data-mp="21kfmbwpppft8">
                  <Link to={l.to} className="text-cream/80 transition-colors duration-150 hover:text-sky" data-id="element-54" data-mp="1wo8oysbdtcmw">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>
        <div className="mx-auto max-w-[1320px] border-t border-cream/15 px-6 py-6 text-sm text-cream/60 md:px-10" data-id="element-55" data-mp="2pcw92kke9vyv">
          © 2026 Association Mieussy 2028 · 74440 Mieussy
        </div>
      </div>
    </footer>;
}